import dayjs from 'dayjs';

export class DateUtils {

  public static formatForTable(date: dayjs.ConfigType) {
    return this.format(date, 'DD/MM/YYYY HH:mm:ss');
  }

  public static formatForOfaDetailsMessage(date: dayjs.ConfigType) {
    return this.format(date, 'DD/MM/YYYY à HH:mm:ss');
  }

  public static formatDateConnexion(date: dayjs.ConfigType) {
    return this.format(date, 'DD/MM/YYYY à HH:mm:ss');
  }

  public static formatDdMmYyyy(date: dayjs.ConfigType) {
    return this.format(date, 'DD/MM/YYYY');
  }

  public static formatForInput(date: dayjs.ConfigType) {
    return this.format(date, 'YYYY-MM-DD');
  }

  public static startOfDayWithoutZone(date: dayjs.ConfigType) {
    if (!date) return '';
    return dayjs(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
  }

  public static endOfDayWithoutZone(date: dayjs.ConfigType) {
    if (!date) return '';
    return dayjs(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
  }

  public static format(date: dayjs.ConfigType, format: string) {
    return (date) ? dayjs(date).format(format) : '';
  }
}